/**
 * @param {HTMLTableElement} selector
 * @return {void}
 */
export function makeTableResponsive (table) {
    // Apply table styles from bootstrap
    table.classList.add('table', 'table-bordered');

    // Mark header cells as columns in thead
    for (const th of [...table.querySelectorAll('thead th')]) {
        th.setAttribute('scope', 'col');
    }

    // Mark header cells as rows in tbody
    for (const th of [...table.querySelectorAll('tbody th')]) {
        th.setAttribute('scope', 'row');
    }

    // Create horisontal scroll container for the table
    const responsiveTableWrap = document.createElement('div');
    responsiveTableWrap.classList.add('table-responsive');

    // Wrap the table
    table.insertAdjacentElement('beforebegin', responsiveTableWrap);
    responsiveTableWrap.appendChild(table);
}